/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_ErrorInputs */

const id_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbandingan tidak dapat dimuat`)
};

const ms_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbandingan tidak dapat dimuatkan`)
};

const da_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenligning kunne ikke indlæses`)
};

const de_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleich konnte nicht geladen werden`)
};

const en_us2_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparison could not be loaded`)
};

const es_es2_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar la comparación`)
};

const es_mx2_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar la comparación`)
};

const fil_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi ma-load ang paghahambing`)
};

const fr_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger la comparaison`)
};

const it_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare il confronto`)
};

const hu_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az összehasonlítás nem tölthető be`)
};

const nl_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergelijking kon niet worden geladen`)
};

const no_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke laste inn sammenligningen`)
};

const pl_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się załadować porównania`)
};

const pt_br2_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar a comparação`)
};

const pt_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar a comparação`)
};

const ro_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compararea nu a putut fi încărcată`)
};

const fi_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertailua ei voitu ladata`)
};

const sv_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det gick inte att läsa in jämförelsen`)
};

const vi_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tải so sánh`)
};

const tr_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karşılaştırma yüklenemedi`)
};

const cs_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porovnání se nepodařilo načíst`)
};

const bg_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнението не може да бъде заредено`)
};

const ru_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить сравнение`)
};

const uk_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося завантажити порівняння`)
};

const ar_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذر تحميل المقارنة`)
};

const hi_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तुलना लोड नहीं हो सकी`)
};

const th_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โหลดการเปรียบเทียบไม่ได้`)
};

const ja_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比較を読み込めませんでした`)
};

const zh_cn2_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法加载比较结果`)
};

const zh_hant1_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法載入比較結果`)
};

const ko_builds_comparison_error = /** @type {(inputs: Builds_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비교를 불러오지 못함`)
};

/**
* | output |
* | --- |
* | "Comparison could not be loaded" |
*
* @param {Builds_Comparison_ErrorInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_error = /** @type {((inputs?: Builds_Comparison_ErrorInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_ErrorInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_error(inputs)
	if (locale === "ms") return ms_builds_comparison_error(inputs)
	if (locale === "da") return da_builds_comparison_error(inputs)
	if (locale === "de") return de_builds_comparison_error(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_error(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_error(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_error(inputs)
	if (locale === "fil") return fil_builds_comparison_error(inputs)
	if (locale === "fr") return fr_builds_comparison_error(inputs)
	if (locale === "it") return it_builds_comparison_error(inputs)
	if (locale === "hu") return hu_builds_comparison_error(inputs)
	if (locale === "nl") return nl_builds_comparison_error(inputs)
	if (locale === "no") return no_builds_comparison_error(inputs)
	if (locale === "pl") return pl_builds_comparison_error(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_error(inputs)
	if (locale === "pt") return pt_builds_comparison_error(inputs)
	if (locale === "ro") return ro_builds_comparison_error(inputs)
	if (locale === "fi") return fi_builds_comparison_error(inputs)
	if (locale === "sv") return sv_builds_comparison_error(inputs)
	if (locale === "vi") return vi_builds_comparison_error(inputs)
	if (locale === "tr") return tr_builds_comparison_error(inputs)
	if (locale === "cs") return cs_builds_comparison_error(inputs)
	if (locale === "bg") return bg_builds_comparison_error(inputs)
	if (locale === "ru") return ru_builds_comparison_error(inputs)
	if (locale === "uk") return uk_builds_comparison_error(inputs)
	if (locale === "ar") return ar_builds_comparison_error(inputs)
	if (locale === "hi") return hi_builds_comparison_error(inputs)
	if (locale === "th") return th_builds_comparison_error(inputs)
	if (locale === "ja") return ja_builds_comparison_error(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_error(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_error(inputs)
	return ko_builds_comparison_error(inputs)
});
export { builds_comparison_error as "builds.comparison.error" }